import {
  ClipboardText,
  Lightbulb,
  PaintBrush,
  ShieldCheck,
} from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";

import { WORKFLOW_CARDS } from "../mockData";

interface SkillCardsProps {
  onCardClick: (workflowType: string) => void;
}

const WORKFLOW_ICONS: Record<string, React.ReactNode> = {
  artwork_review: <PaintBrush size={22} className="text-puntt-pink-9" weight="duotone" />,
  brief_creation: <ClipboardText size={22} className="text-puntt-accent-9" weight="duotone" />,
  compliance_review: <ShieldCheck size={22} className="text-malachite-700" weight="duotone" />,
  claim_generation: <Lightbulb size={22} className="text-puntt-gold-9" weight="duotone" />,
};

const WORKFLOW_ICON_BG: Record<string, string> = {
  artwork_review: "bg-puntt-pink-2 ring-1 ring-puntt-pink-5/50",
  brief_creation: "bg-puntt-accent-2 ring-1 ring-puntt-accent-5/50",
  compliance_review: "bg-malachite-50 ring-1 ring-malachite-200/50",
  claim_generation: "bg-puntt-gold-2 ring-1 ring-puntt-gold-5/50",
};

/** @deprecated Use SkillCards instead */
export function WorkflowCards({ onCardClick }: SkillCardsProps) {
  return <SkillCards onCardClick={onCardClick} />;
}

export function SkillCards({ onCardClick }: SkillCardsProps) {
  return (
    <div className="grid grid-cols-4 gap-3">
      {WORKFLOW_CARDS.map((card) => (
        <button
          key={card.id}
          data-testid={`ask-puntt-skill-card-${card.workflowType}`}
          onClick={() => onCardClick(card.workflowType)}
          className="group flex flex-col gap-2 rounded-2xl border border-puntt-neutral-gray-5 bg-base-white p-5 text-left shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-puntt-accent-7 hover:shadow-lg"
        >
          <div className={`flex size-10 items-center justify-center rounded-xl transition-all duration-300 group-hover:scale-105 group-hover:ring-2 ${WORKFLOW_ICON_BG[card.workflowType] ?? "bg-puntt-neutral-gray-2"}`}>
            {WORKFLOW_ICONS[card.workflowType]}
          </div>
          <Text size="3" weight="bold" className="text-puntt-neutral-gray-12">
            {card.title}
          </Text>
          <Text size="1" className="leading-relaxed text-puntt-neutral-gray-11">
            {card.description}
          </Text>
        </button>
      ))}
    </div>
  );
}
